import { useSubjects as useCoreSubjects, SubjectsHookOutput } from '@ts-core/modules/subjects/hooks';

import { subjectsTreeFragment } from '../graphql/fragments';

import { Subject } from '../types';

interface SubjectsHookInput {
  courseId: string;
}

export default function useSubject(input: SubjectsHookInput): SubjectsHookOutput<Subject> {
  return useCoreSubjects({ ...input, subjectsTreeFragment });
}
